import { render } from "./PujolPayment.vue?vue&type=template&id=55313ff1&lang=pug"
import script from "./PujolPayment.vue?vue&type=script&lang=js"
export * from "./PujolPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__